<template>
  <div class="video-frame" :class="type">
    <iframe id="ytplayer" type="text/html" width="100%" height="100%"
  :src="`https://www.youtube.com/embed/${videoShareIframeText}?autoplay=1`"
  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;" allowfullscreen @load="handleLoad" @error="handleError"></iframe>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import videoIframeMap from './videoIframeMap'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import { loadingService } from '@/utils/loadingService'
const type = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
const videoShareIframeText = computed(() => {
  let key = ''
  if (['en', 'sg', 'my', 'ph', 'in'].includes(locale.value)) {
    key = 'en'
  } else if (['hk', 'tw'].includes(locale.value)) {
    key = 'hk'
  } else if(['vi'].includes(locale.value)) {
    key = 'vi'
  } else if(['th'].includes(locale.value)) {
    key = 'th'
  } else if(['id'].includes(locale.value)) {
    key = 'id'
  } else {
    key = 'en'
  }
  console.log(videoIframeMap[key], )
  let res = videoIframeMap[key] || videoIframeMap.en
  // if (res) {
  //   res = res.replace(/height="[0-9]+"/, 'height="100%"')
  //   res = res.replace(/width="[0-9]+"/, 'width="100%"')
  // }
  return res
})
const loading = ref(true)
loadingService.show()
const handleLoad = () => {
  if (loading.value) {
    loading.value = false
    loadingService.hide()
  }
}
const handleError = () => {
  if (loading.value) {
    loading.value = false
    loadingService.hide()
  }
}

setTimeout(() => {
  loading.value = true
  loadingService.hide()
}, 5000)

</script>

<style lang="less" scoped src="./mobile_style.less"></style>
<style lang="less" scoped src="./pc_style.less"></style>
